import createAPI from '../axios'

// 学分认定API
const creditIdentified = {
	changeMajor: {

        initCombo: config => createAPI('/creditIdentified/changeMajor/initCombo', 'post', config),

	    list: config => createAPI('/creditIdentified/changeMajor/list', 'post', config),

        courseCombo: config => createAPI('/creditIdentified/changeMajor/courseCombo', 'post', config),

        save: config => createAPI('/creditIdentified/changeMajor/save', 'post', config),
        
        submit: config => createAPI('/creditIdentified/changeMajor/submit', 'post', config),

        updateAuditState: config => createAPI('/creditIdentified/changeMajor/updateAuditState', 'post', config),

        del: config => createAPI('/creditIdentified/changeMajor/del', 'post', config),
	}
};

export default creditIdentified;



// WEBPACK FOOTER //
// ./src/api/modules/creditIdentified.js